goog.provide("shadow.js.shim.module$dayjs$plugin$advancedFormat");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$advancedFormat");
shadow.js.shim.module$dayjs$plugin$advancedFormat = shadow.js.nativeProvides["dayjs/plugin/advancedFormat"] = require("dayjs/plugin/advancedFormat");
module$shadow_js_shim_module$dayjs$plugin$advancedFormat.default = shadow.js.shim.module$dayjs$plugin$advancedFormat;
